import { Currency } from '../../constants/currency.js';
import { getAmountRangeToString } from '../../helpers/humanization.js';

const getAccumulativeDepositTerms = item => {
    const conditions = [];
    const { term, effectiveRate, amount } = item;
    const amountValue = getAmountRangeToString({ amountRange: amount, currency: Currency.RUB });
    effectiveRate && conditions.push({ value: `${effectiveRate}`, description: 'ставка в год', key: 'rate' });
    amountValue &&
        conditions.push({
            value: amountValue,
            description: `Сумма`,
            wide: true,
            key: 'amount',
            labelKey: 'term',
        });
    term &&
        conditions.push({
            value: term,
            SOValue: `на срок ${term}`,
            description: `Срок`,
            wide: true,
            key: 'term',
        });
    return conditions;
};

export { getAccumulativeDepositTerms };
//# sourceMappingURL=accumulativeDeposit.js.map
